import { api_GET, api_POST, api_PUT } from "./_api.js";

const modelosEmail_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("ModeloEmail")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("ModeloEmail/GetListAtivos")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModeloEmail/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (modeloEmail) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("ModeloEmail", modeloEmail)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (modeloEmail) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("ModeloEmail", modeloEmail)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default modelosEmail_api;
